import(/* webpackMode: "eager", webpackExports: ["ChainGovernance"] */ "/vercel/path0/components/chain-governance.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["DashboardHeader"] */ "/vercel/path0/components/dashboard-header.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["FeaturedDAOs"] */ "/vercel/path0/components/featured-daos.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["PushNotificationStub"] */ "/vercel/path0/components/push-notification-stub.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Sidebar"] */ "/vercel/path0/components/sidebar.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["StatsOverview"] */ "/vercel/path0/components/stats-overview.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["SubDAOStats"] */ "/vercel/path0/components/subdao-stats.tsx");
